import SidebarLayout from './SidebarLayout'
import { useAuth } from '../../contexts/AuthContext'

// ── Infra Admin Layout ────────────────────────────────────────────────────────
export function InfraAdminLayout() {
  const navGroups = [
    {
      label: 'Overview',
      items: [
        { label: 'Dashboard',    to: '/infra/admin',              end: true, icon: '⊞' },
        { label: 'Health',       to: '/infra/admin/health',       icon: '💚' },
        { label: 'Reports',      to: '/infra/admin/reports',      icon: '📊' },
      ],
    },
    {
      label: 'Clients',
      items: [
        { label: 'Clients',      to: '/infra/admin/clients',      icon: '👥' },
        { label: 'Projects',     to: '/infra/admin/projects',     icon: '📁' },
        { label: 'Environments', to: '/infra/admin/environments', icon: '🖥' },
      ],
    },
    {
      label: 'Infrastructure',
      items: [
        { label: 'Maintenance',  to: '/infra/admin/maintenance',  icon: '🔧' },
        { label: 'Backups',      to: '/infra/admin/backups',      icon: '💾' },
        { label: 'SSL Certs',    to: '/infra/admin/ssl',          icon: '🔒' },
        { label: 'Runbooks',     to: '/infra/admin/runbooks',     icon: '📖' },
        { label: 'Custom Tasks', to: '/infra/admin/custom-tasks', icon: '⚡' },
      ],
    },
    {
      label: 'Support',
      items: [
        { label: 'Tickets',      to: '/infra/admin/tickets',      icon: '🎫' },
        { label: 'Inquiries',    to: '/infra/admin/contact-submissions', icon: '📨' },
        { label: 'Domain Listings', to: '/infra/admin/domain-listings', icon: '🌐' },
        { label: 'SLA Policies', to: '/infra/admin/sla',          icon: '⏱' },
        { label: 'Service Req.', to: '/infra/admin/service-requests', icon: '📝' },
        { label: 'Canned Resp.', to: '/infra/admin/canned-responses', icon: '💬' },
      ],
    },
    {
      label: 'Finance',
      items: [
        { label: 'Billing',      to: '/infra/admin/billing',      icon: '💳' },
        { label: 'Invoices',     to: '/infra/admin/invoices',     icon: '🧾' },
      ],
    },
    {
      label: 'Config',
      items: [
        { label: 'Users',        to: '/infra/admin/users',        icon: '👤' },
        { label: 'Integrations', to: '/infra/admin/integrations', icon: '🔌' },
        { label: 'Prospect Hunter', to: '/infra/admin/prospects',        icon: '🎯' },
        { label: 'Hunter Setup',    to: '/infra/admin/prospects/config', icon: '🔧' },
        { label: 'Sequences',       to: '/infra/admin/prospects/sequences', icon: '🔁' },
        { label: 'Alerts',       to: '/infra/admin/notification-rules', icon: '🔔' },
        { label: 'Content',      to: '/infra/admin/content',      icon: '📰' },
        { label: 'Settings',     to: '/infra/admin/settings',     icon: '⚙️' },
        { label: 'Credentials',  to: '/infra/admin/platform-credentials', icon: '🔐' },
      ],
    },
  ]
  return <SidebarLayout navGroups={navGroups} moduleColor="#1A6AF5" moduleTag="SYSTEZA INFRA — ADMIN" />
}

// ── Infra Client Layout ───────────────────────────────────────────────────────
export function InfraClientLayout() {
  const navGroups = [
    {
      items: [
        { label: 'Dashboard',      to: '/infra/client',                   end: true, icon: '⊞' },
        { label: 'Projects',       to: '/infra/client/projects',          icon: '📁' },
        { label: 'Tickets',        to: '/infra/client/tickets',           icon: '🎫' },
        { label: 'Maintenance',    to: '/infra/client/maintenance',       icon: '🔧' },
        { label: 'Reports',        to: '/infra/client/reports',           icon: '📊' },
        { label: 'Billing',        to: '/infra/client/billing',           icon: '💳' },
        { label: 'Service Req.',   to: '/infra/client/service-requests',  icon: '📝' },
        { label: 'Team',           to: '/infra/client/team',              icon: '👥' },
        { label: 'API Tokens',     to: '/infra/client/api-tokens',        icon: '🔑' },
        { label: 'Agency Billing', to: '/infra/client/agency/billing',    icon: '🏢' },
        { label: 'Retainer',      to: '/infra/client/upgrades/retainer', icon: '🔄' },
        { label: 'Notifications',  to: '/infra/client/notifications',     icon: '🔔' },
        { label: 'Help Center',    to: '/infra/client/help',              icon: '❓' },
      ],
    },
  ]
  return <SidebarLayout navGroups={navGroups} moduleColor="#1A6AF5" moduleTag="SYSTEZA INFRA — CLIENT" />
}

// ── Automations Layout ────────────────────────────────────────────────────────
export function AutomationsLayout() {
  const navGroups = [
    {
      items: [
        { label: 'Dashboard',      to: '/automations',                         end: true, icon: '⊞' },
        { label: 'Projects',       to: '/automations/projects',                icon: '⬡' },
        { label: 'Documents',      to: '/automations/documents',               icon: '📄' },
        { label: 'Specifications', to: '/automations/specifications',          icon: '◈' },
        { label: 'Test Plans',     to: '/automations/test-plans',              icon: '✓' },
        { label: 'Search',        to: '/automations/search',                  icon: '🔍' },
        { label: 'AI Usage',      to: '/automations/ai-usage',               icon: '🧠' },
        { label: 'Code Analysis', to: '/automations/code-analysis',          icon: '🔬' },
        { label: 'Versions',      to: '/automations/versions',                icon: '🕒' },
        { label: 'Changelog',     to: '/automations/changelog',               icon: '📋' },
        { label: 'Notifications', to: '/automations/notifications',          icon: '🔔' },
        { label: 'Integrations',  to: '/automations/integrations',           icon: '🔌' },
        { label: 'Notif Log',     to: '/automations/notifications/log',      icon: '📨' },
        { label: 'Billing',        to: '/automations/billing',                 icon: '💳' },
        { label: 'Settings',       to: '/automations/settings',                icon: '⚙️' },
      ],
    },
  ]
  return <SidebarLayout navGroups={navGroups} moduleColor="#00C8E8" moduleTag="SYSTEZA AUTOMATIONS" />
}

// ── Engage Layout ─────────────────────────────────────────────────────────────
export function EngageLayout() {
  const navGroups = [
    {
      label: 'Overview',
      items: [
        { label: 'Dashboard',       to: '/engage',                         end: true, icon: '⊞' },
        { label: 'Analytics',       to: '/engage/analytics',               icon: '📈' },
        { label: 'UTM Analytics',   to: '/engage/utm-analytics',           icon: '🔗' },
        { label: 'Funnel Analytics',to: '/engage/funnel-analytics',        icon: '🔽' },
        { label: 'ROI Tracking',    to: '/engage/roi-tracking',            icon: '💰' },
      ],
    },
    {
      label: 'Contacts & Leads',
      items: [
        { label: 'All Contacts',    to: '/engage/contacts',                icon: '📋' },
        { label: 'Pipeline',        to: '/engage/pipeline',                icon: '🔀' },
        { label: 'Campaigns',       to: '/engage/campaigns',               icon: '📧' },
        { label: 'Sequences',       to: '/engage/sequences',               icon: '📬' },
        { label: 'Subscribers',     to: '/engage/subscribers',             icon: '👥' },
        { label: 'SLA Tracking',    to: '/engage/sla',                     icon: '⏱' },
        { label: 'Live Chat',       to: '/engage/live-chat',               icon: '💬' },
      ],
    },
    {
      label: 'Automation',
      items: [
        { label: 'Workflows',       to: '/engage/workflows',               icon: '⚡' },
        { label: 'Auto-Tag Rules',  to: '/engage/auto-tags',               icon: '🏷' },
        { label: 'Chatbot Flows',   to: '/engage/chatbot-flows',           icon: '🤖' },
        { label: 'Funnel Builder',  to: '/engage/funnel-builder',          icon: '🔧' },
        { label: 'Approvals',       to: '/engage/approvals',               icon: '✅' },
      ],
    },
    {
      label: 'Content & Social',
      items: [
        { label: 'Content Studio',  to: '/engage/content-studio',         icon: '✍️' },
        { label: 'Social Scheduler',to: '/engage/social-scheduler',       icon: '📅' },
        { label: 'Media Library',   to: '/engage/media-library',          icon: '🖼' },
        { label: 'Hashtag Manager', to: '/engage/hashtag-manager',        icon: '#️⃣' },
        { label: 'RSS Feeds',       to: '/engage/rss-feeds',              icon: '📡' },
        { label: 'Creative Studio', to: '/engage/creative-studio',        icon: '🎨' },
        { label: 'SEO Tools',       to: '/engage/seo-tools',              icon: '🔍' },
      ],
    },
    {
      label: 'Channels & Tools',
      items: [
        { label: 'Domains',         to: '/engage/domains',                icon: '🌐' },
        { label: 'Email Templates', to: '/engage/templates',              icon: '📝' },
        { label: 'Webhook Logs',    to: '/engage/webhooks',               icon: '🪝' },
        { label: 'Shopify',         to: '/engage/shopify',                icon: '🛒' },
        { label: 'Clients',         to: '/engage/client-accounts',        icon: '💼' },
      ],
    },
    {
      label: 'Account',
      items: [
        { label: 'Billing',         to: '/engage/billing',                icon: '💳' },
        { label: 'GDPR',            to: '/engage/gdpr',                   icon: '🛡' },
        { label: 'Audit Log',       to: '/engage/audit-log',              icon: '🕐' },
        { label: 'Settings',        to: '/engage/settings',               icon: '⚙️' },
      ],
    },
  ]
  return <SidebarLayout navGroups={navGroups} moduleColor="#00E5C8" moduleTag="SYSTEZA ENGAGE" />
}

// ── Hub Layout ────────────────────────────────────────────────────────────────
export function HubLayout() {
  const navGroups = [
    {
      items: [
        { label: 'Marketplace',     to: '/hub',                  end: true, icon: '🧩' },
        { label: 'My Integrations', to: '/hub/integrations',     icon: '🔌' },
        { label: 'Webhooks',        to: '/hub/webhooks',         icon: '🪝' },
        { label: 'API Keys',        to: '/hub/api-keys',         icon: '🔑' },
        { label: 'API Docs',        to: '/hub/api-docs',         icon: '📚' },
      ],
    },
  ]
  return <SidebarLayout navGroups={navGroups} moduleColor="#A855F7" moduleTag="SYSTEZA HUB" />
}

// ── Platform Admin Layout ─────────────────────────────────────────────────────
// The cross-tenant operator surface. Settings is hidden below super_admin
// because the API refuses it at that rank anyway — showing a link that always
// 403s is worse than not showing it.
export function PlatformLayout() {
  const { isPlatformSuperAdmin } = useAuth()

  const navGroups = [
    {
      label: 'Overview',
      items: [
        { label: 'Dashboard',   to: '/platform',        end: true, icon: '⊞' },
        { label: 'Health',      to: '/platform/health',            icon: '💚' },
      ],
    },
    {
      label: 'People',
      items: [
        { label: 'Users',            to: '/platform/users',             icon: '👤' },
        { label: 'Erasure Requests', to: '/platform/account-deletions', icon: '🗑' },
        { label: 'Audit Log',        to: '/platform/audit',             icon: '🕐' },
      ],
    },
    {
      label: 'Operations',
      items: [
        { label: 'Feature Flags', to: '/platform/feature-flags', icon: '🚩' },
        { label: 'Maintenance',   to: '/platform/maintenance',   icon: '🚧' },
        { label: 'Announcements', to: '/platform/announcements', icon: '📣' },
        { label: 'Email Templates', to: '/platform/email-templates', icon: '✉️' },
      ],
    },
    {
      label: 'Insight',
      items: [
        { label: 'AI Usage',       to: '/platform/ai-usage',       icon: '🧠' },
        { label: 'Deliverability', to: '/platform/deliverability', icon: '📬' },
        { label: 'Integrations',   to: '/platform/integrations',   icon: '🔌' },
        { label: 'Exports',        to: '/platform/exports',        icon: '⬇' },
      ],
    },
  ]

  if (isPlatformSuperAdmin) {
    navGroups.push({
      label: 'Restricted',
      items: [{ label: 'Settings', to: '/platform/settings', icon: '🔐' }],
    })
  }

  return <SidebarLayout navGroups={navGroups} moduleColor="#F59E0B" moduleTag="SYSTEZA PLATFORM" />
}
